import React from 'react';
import BadgeStatus from '../../../atoms/BadgeStatus';
import { CHANNELS, Group, MessageComposition } from '../../../../types/communication';
import { ChannelTile } from '../composition/shared/channelVisuals';
import { UserAvatarStack } from './UserAvatar';

interface GroupRowProps {
    group: Group;
    models: MessageComposition[];
    striped: boolean;
    onOpen: () => void;
}

const GroupRow: React.FC<GroupRowProps> = ({ group, models, striped, onOpen }) => {
    const active = group.status === 'ACTIVE';
    const members = group.users.filter((u) => u.active).map((u) => u.login);
    return (
        <tr
            onClick={onOpen}
            className={`${striped ? 'bg-slate-50 dark:bg-slate-800' : 'bg-white dark:bg-slate-900'} border-b border-gray-200 dark:border-slate-700 cursor-pointer hover:bg-teal-50/60 dark:hover:bg-slate-700`}
        >
            <td className="py-2.5 px-2">
                <div className="text-sm font-medium text-gray-900 dark:text-gray-100">{group.name}</div>
                <div className="text-xs text-gray-500 truncate max-w-md" title={group.description}>
                    {group.description || '—'}
                </div>
            </td>
            <td className="py-2.5 px-2">
                <UserAvatarStack logins={members} />
            </td>
            <td className="py-2.5 px-2">
                {models.length ? (
                    <div className="flex items-center gap-2">
                        {CHANNELS.map((channel) => {
                            const count = models.filter((m) => m.channel === channel).length;
                            return count ? (
                                <span key={channel} className="inline-flex items-center gap-1 text-xs text-gray-600 dark:text-gray-300">
                                    <ChannelTile channel={channel} size="sm" />
                                    {count}
                                </span>
                            ) : null;
                        })}
                    </div>
                ) : (
                    <span className="text-xs text-gray-400">Nenhum</span>
                )}
            </td>
            <td className="py-2.5 px-2">
                <BadgeStatus color={active ? 'green' : 'red'} text={active ? 'Ativo' : 'Inativo'} />
            </td>
        </tr>
    );
};

export default GroupRow;
